
export const getExperienceName = (id, resolve) => {
  let response;
  let matchFound = false;
  if (typeof window.ttMETA !== 'undefined') {
    const adobeTargetExperiments = window.ttMETA || {};
    try {
      adobeTargetExperiments.forEach(experiment => {
        if (experiment.ActivityId === id) {
          matchFound = true;
          response = experiment.ExperienceName;
          resolve(response);
        }
      });
      // if we do not find an ExperienceName match, return false
      if(!matchFound){
        resolve(false);
      }
    }catch(error){
      // default to control in the event of an error
      console.error('Error trying to set Adobe Target experiment index');
    }
  }
  return false;
};

// it is necessary to wait for adobe target to be loaded first before we render anything, or else we get nasty content flashing.
export const waitForAdobeTarget = (activityId, resolve) => {
  let counter = 0;
  counter += 1;
  setTimeout(() => {
    // only run set timeout for 30 iterations before quitting.
    if(counter < 30){
      if(!window.ttMETA){
        // keep waiting for adobe target
        waitForAdobeTarget(activityId, resolve);
      } else {
        // Adobe target has loaded. Stop iterating and rerender the component
        getExperienceName(activityId, resolve);
      }
    }
  }, 50);
};

export const getExperienceNameFromAdobeTarget = (activityId) => {
  return new Promise((resolve) => {
    waitForAdobeTarget(activityId, resolve);
  });
};

export default (activityId) => {
  return getExperienceNameFromAdobeTarget(activityId);
};
